import { z } from 'zod';

export const BrokersMetadataSchema = z.object({
  total: z.number(),
});

export type BrokersMetadata = z.infer<typeof BrokersMetadataSchema>;
